import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const carouselHandler = {
  settings: {
    classNames: {
      carouselWrapper: '.js-carousel-wrapper',
    },
    defaults: {
      items: 1,
      slideBy: 'page',
      autoplay: false,
      nav: true,
    },
  },

  init() {
    if (typeof document === 'undefined') return;
    const nodes = document.querySelectorAll(this.settings.classNames.carouselWrapper);
    if (!nodes.length) return;
    this.setupCarousel(nodes);
  },

  setupCarousel(nodes: NodeListOf<Element>) {
    nodes.forEach((el) => {
      const slidesPerView = this.settings.defaults.items;
      const slidesPerGroup = this.settings.defaults.slideBy === 'page' ? slidesPerView : 1;
      const scope = (el as HTMLElement).closest('.module__content') ?? (el as HTMLElement).parentElement ?? document;
  
      const prevEl = scope.querySelector('.carousel-controls .swiper-button-prev') as HTMLElement | null;
      const nextEl = scope.querySelector('.carousel-controls .swiper-button-next') as HTMLElement | null;
      const indexEl = scope.querySelector('.carousel-controls .swiper-index') as HTMLElement | null;
  
      const slideCount = (el as HTMLElement).querySelectorAll('.swiper-slide').length;
      const enableLoop = slideCount > slidesPerView; // avoid Swiper disabling nav after one move
  
      const opts: any = {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        updateOnWindowResize: true,
        // helps with tiny carousels
        loopAdditionalSlides: 1,
        ...(this.settings.defaults.autoplay && { autoplay: { delay: 3000 } }),
        on: {
          imagesReady(sw: any) { sw.update(); },
        },
      };
  
      if (this.settings.defaults.nav && nextEl && prevEl) {
        opts.navigation = { nextEl, prevEl };
      }
  
      const swiper = new Swiper(el as HTMLElement, opts);
      swiper.update(); // ensure first measure after grid/images
  
      if (indexEl) {
        const updateIndex = () => {
          const n = (swiper.realIndex + 1).toString().padStart(2, '0');
          indexEl.textContent = n;
        };
        updateIndex();
        swiper.on('slideChange', updateIndex);
      }
    });
  }  
};

export { carouselHandler };
